(function(){
  function build(root){
    var list=root.querySelector(".mega-menu__list");
    if(!list||root.querySelector(".fs-mega"))return;
    var groups=Array.prototype.slice.call(list.children);
    var wrap=document.createElement("div");wrap.className="fs-mega page-width";
    var rail=document.createElement("div");rail.className="fs-rail";
    var panes=document.createElement("div");panes.className="fs-panes";
    var first=-1;
    groups.forEach(function(li,i){
      var head=li.querySelector(":scope > a");
      var sub=li.querySelector(":scope > ul");
      if(!head)return;
      if(!sub){
        var q=document.createElement("a");q.className="fs-quick";
        q.href=head.getAttribute("href");q.textContent=head.textContent.trim();
        rail.appendChild(q);return;
      }
      var links=Array.prototype.slice.call(sub.querySelectorAll("a"));
      var allLink=null;
      links=links.filter(function(a){if(!allLink&&a.getAttribute("href")===head.getAttribute("href")){allLink=a;return false;}return true;});
      var btn=document.createElement("button");btn.type="button";btn.className="fs-tab";
      btn.setAttribute("data-i",i);btn.setAttribute("aria-selected","false");
      var s=document.createElement("span");s.textContent=head.textContent.trim();
      var em=document.createElement("em");em.textContent=links.length;
      btn.appendChild(s);btn.appendChild(em);rail.appendChild(btn);
      var pane=document.createElement("div");pane.className="fs-pane";pane.setAttribute("data-i",i);
      var h=document.createElement("a");h.className="fs-pane-head";
      h.href=head.getAttribute("href");h.textContent=head.textContent.trim();
      var cols=document.createElement("div");cols.className="fs-cols";
      links.forEach(function(a){var c=a.cloneNode(true);c.classList.add("fs-link");cols.appendChild(c);});
      pane.appendChild(h);
      if(allLink){var ha=allLink.cloneNode(true);ha.className="fs-all";ha.textContent=allLink.textContent.trim();pane.appendChild(ha);}
      pane.appendChild(cols);panes.appendChild(pane);
      if(first<0)first=i;
    });
    if(first<0)return;
    wrap.appendChild(rail);wrap.appendChild(panes);
    list.style.display="none";list.parentNode.insertBefore(wrap,list);
    function select(i){
      Array.prototype.forEach.call(wrap.querySelectorAll(".fs-tab"),function(b){
        b.setAttribute("aria-selected",b.getAttribute("data-i")===String(i));});
      Array.prototype.forEach.call(wrap.querySelectorAll(".fs-pane"),function(p){
        if(p.getAttribute("data-i")===String(i))p.classList.add("on");else p.classList.remove("on");});
    }
    rail.addEventListener("mouseover",function(e){var b=e.target.closest(".fs-tab");if(b)select(b.getAttribute("data-i"));});
    rail.addEventListener("focusin",function(e){var b=e.target.closest(".fs-tab");if(b)select(b.getAttribute("data-i"));});
    rail.addEventListener("click",function(e){var b=e.target.closest(".fs-tab");if(b){e.preventDefault();select(b.getAttribute("data-i"));}});
    select(first);
  }
  function run(){Array.prototype.forEach.call(document.querySelectorAll(".mega-menu__content"),build);}
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",run);else run();
})();
